import { Sidebar } from '@payaca/ambrosia';
import { FC, useMemo, type JSX } from 'react';

import { TimelogLinkedEntity } from '@payaca/types/timelogs';
import EntityTimelogsControl from '../entityTimelogsControl/EntityTimelogsControl';

type Props = {
  newTimelogsInitialStartTime?: Date;
  isOpen: boolean;
  onClose?: () => void;
  entity: Pick<
    TimelogLinkedEntity,
    'entityType' | 'entityId' | 'entityReadableIdentifier'
  >;
};

const EntityTimelogsDrawer: FC<Props> = ({
  isOpen,
  onClose,
  entity,
  newTimelogsInitialStartTime,
}: Props): JSX.Element | null => {
  const readableType = useMemo(() => {
    switch (entity.entityType) {
      case 'deal':
        return 'Project';
      case 'task':
        return 'Task';
      case 'scheduledEvent':
        return 'Event';

      case 'customer':
        return 'Customer';
      default:
        return 'Entity';
    }
  }, [entity.entityType]);

  const title = entity.entityReadableIdentifier?.length
    ? `Timelogs for ${readableType}: ${entity.entityReadableIdentifier}`
    : `Timelogs for ${readableType}`;

  return (
    <Sidebar isOpen={isOpen} onClose={onClose} title={title}>
      <Sidebar.Body className="p-4">
        <EntityTimelogsControl
          entity={entity}
          newTimelogsInitialStartTime={newTimelogsInitialStartTime}
        />
      </Sidebar.Body>
    </Sidebar>
  );
};
export default EntityTimelogsDrawer;
